<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_SubscribeToDataAlerts')"
    width="1030px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view reminder-form"
    @close="close"
  >
    <div class="main-content">
      <el-tabs v-model="tabName" type="card" style="width:100%">
        <el-tab-pane :label="$t('SystemMaintenance.DataService')" name="dataService" :lazy="true">
          <div style="width: fit-content">
            <div style="display: flex">
              <div class="section form-column content-wrapper">
                <el-form
                  :disabled="readonly"
                  label-width="100px"
                  label-position="left"
                >
                  <el-form-item :label="$t('CargoMsg.Cargo_WarningSwitch')">
                    <el-radio-group v-model="form.open">
                      <el-radio :label="1">{{ $t('CargoMsg.Cargo_StartAlert') }}</el-radio>
                      <el-radio :label="0">{{ $t('CargoMsg.Cargo_CloseAlert') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_NodPushSettings')">
                    <el-radio-group v-model="form.userConfigOpen">
                      <el-radio :label="1">{{ $t('CargoMsg.Cargo_EnablePersonalSettings') }}</el-radio>
                      <el-radio :label="0">{{ $t('CargoMsg.Cargo_ClosePersonalSettings') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_WarningConditions')">
                    <el-checkbox-group v-model="ruleItem" style="width: 405px">
                      <el-checkbox v-for="(item, index) in warningTypes" :key="index" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="$t('Message.PortOfDepartureUpdate')">
                    <el-checkbox-group v-model="ruleItem" style="width: 405px">
                      <el-checkbox v-for="(item, index) in portAreaReminder" :key="index" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
                      <br>
                      <el-checkbox v-for="(item, index) in nodeAlertTypes" :key="index+1" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_ShipPlanReminderMethod')">
                    <el-radio-group v-model="form.vesselReminderMethod" @change="changeVesselReminderMethod">
                      <el-radio :label="0" style="margin-right: 5px">{{ $t('CargoMsg.Cargo_ShipNameAndVoyage') }}</el-radio>
                      <el-radio :label="1" style="margin-right: 5px">{{ $t('CargoMsg.Cargo_Job') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="$t('Message.DestinationPortUpdate')">
                    <el-checkbox-group v-model="ruleItem" style="width: 405px">
                      <el-checkbox v-for="(item, index) in DestinationPortNodeAlertTypes" :key="index" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_AutoIgnoreMode')">
                    <el-radio-group v-model="form.ignoreType" @input="selectType">
                      <div style="display: flex">
                        <el-radio style="margin-top: 5px" :label="1">{{ $t('CargoMsg.Cargo_EarlyTimedIgnore') }}</el-radio>
                        <el-input-number v-model="form.ignoreTime" :disabled="form.ignoreType === 0" controls-position="right" style="width: 120px !important; margin-right: 5px" oninput="value=value.replace(/[^\d]/g,'')" />
                        <span style="margin-top: 5px">{{ $t('CargoMsg.Cargo_AutomaticallyIgnoreAfterHours') }}</span>
                      </div>
                      <el-radio style="margin-top: 5px" :label="0">{{ $t('CargoMsg.Cargo_TurnOffAutoIgnore') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_WarningLevel')">
                    <el-radio-group v-for="item in levels" :key="item.code" v-model="form.level">
                      <el-radio :label="item.code" style="margin-right: 5px">{{ isZh ? item.chineseName : item.englishName }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_RemarksInfo')">
                    <el-input v-model="form.remark" type="textarea" />
                  </el-form-item>
                  <el-form-item :label="$t('BusinessIntelligence.businessIntelligenceChart.warmPrompt')">
                    <div style="width: 380px">
                      <span>{{ $t('CargoMsg.Cargo_DataServiceReminderWarningOne') }}</span>
                      <span>{{ $t('CargoMsg.Cargo_DataServiceReminderWarning') }}</span>
                      <a style="color: #1f75d5" @click="learnMore">{{ $t('CargoMsg.Cargo_ClickToLearnMore') }}</a>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
              <div class="section form-column content-wrapper">
                <el-form
                  :disabled="readonly"
                  label-width="100px"
                  label-position="left"
                >
                  <el-form-item>
                    <span slot="label" style="color: #1F75D5">{{ $t('SystemMaintenance.ConfigurationName') }}</span>
                    <el-input v-model="form.configureName" style="width: 300px;" />
                  </el-form-item>
                  <span class="title">{{ $t('CargoMsg.Cargo_DocumentNotification') }}</span>
                  <div style="margin: 10px;">
                    <el-radio-group v-model="form.notifyJobType">
                      <el-radio style="margin-bottom: 5px" :label="0">{{ $t('CargoMsg.Cargo_NoticeOfEachBill') }}</el-radio>
                      <el-radio :label="1">{{ $t('CargoMsg.Cargo_NoNoticeOfTickets') }}</el-radio>
                    </el-radio-group>
                  </div>
                  <span class="title">{{ $t('CargoMsg.Cargo_SetAlertNotificationObject') }}</span>
                  <div style="margin-left: 10px">
                    <div>
                      <el-checkbox v-model="hasDesignatedPost">{{ $t('CargoMsg.Cargo_DesignatedPost') }}</el-checkbox>
                    </div>
                    <el-checkbox-group v-model="notifierRoles" style="margin-left: 10px" :disabled="!hasDesignatedPost">
                      <el-checkbox v-for="(item, index) in roles" :key="index" style="margin-top: 10px" :label="item.code">{{ isZh ? item.chineseName : item.englishName }}</el-checkbox>
                    </el-checkbox-group>
                    <div style="margin-top: 10px">
                      <el-checkbox v-model="hasNotifierIds" @change="notifierIds=[]">{{ $t('CargoMsg.Cargo_DesignatedPersonnel') }}</el-checkbox>
                      <cargo-advance-select
                        :select-type="selectTypeNames.basic_data_User"
                        :fields="['chineseName']"
                        :disabled="!hasNotifierIds"
                        :callback-params="{key:'userList'}"
                        callback-method-type="value"
                        tag-value="userId"
                        tag-name="chineseName"
                        :filter-tag-names="['chineseName']"
                        :method-params="{pageSize: 1000000, active: true, hasRole: true}"
                        :default-multiple-value="notifierIds"
                        multiple
                        filterable
                        style="width:205px;margin-top: 10px"
                        options-width="230px"
                        @parentCallBack="p=>{notifierIds=p.value}"
                      />
                    </div>
                  </div>
                  <span style="margin-top: 10px" class="title">{{ $t('CargoMsg.Cargo_ReminderModes') }}</span>
                  <div>
                    <el-checkbox v-model="enableMail">{{ $t('Viewer.email') }}</el-checkbox>
                    <el-checkbox v-model="enableWeChat">{{ $t('CargoMsg.Cargo_Wechat') }}</el-checkbox>
                    <el-checkbox v-show="showEnableEnterpriseWechat" v-model="enableEnterpriseWechat">{{ $t('CargoMsg.Cargo_EnterpriseWechat')+$t('CargoMsg.Cargo_EnterpriseWechat2DataServiceReminder') }}</el-checkbox>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="commitHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      <el-button @click="close">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getWarningRuleList, saveWarningRule, checkDataServiceSave } from '@/api/sysManage/baseConfig/warnRuleConfiguration'
import { deepClone } from '@/utils'
import * as commonUtil from '@/utils/commonUtil'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import LocalStorageUtils from '@/utils/localStorageUtils'
import ColumnUtils from '@/utils/ColumnUtils'
export default {
  name: 'DataServiceReminderForm',
  components: { CargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    params: {
      type: Object,
      default: () => {}
    },
    openSubscribe: { // 是否开通港区服务
      type: Boolean,
      default: () => false
    },
    alertTypes: {
      type: Array,
      default: () => []
    },
    loadData: { // 是否加载数据
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      form: {
        warningRuleItemList: [{ ruleItem: '' }],
        type: 2,
        open: 0,
        userConfigOpen: 0,
        ignoreType: 0,
        level: 0,
        ignoreTime: '',
        notifierRoles: '1,2',
        notifierIds: '',
        enableMail: true,
        enableWeChat: false,
        enableEnterpriseWechat: false,
        notifyJobType: 0,
        vesselReminderMethod: 0,
        configureName: '默认配置',
        content: '数据服务提醒'
      },
      fullscreenLoading: null,
      isZh: this.$store.getters.language === 'zh',
      roles: CargoOfRoleType.WARNING_ROLE_TYPES,
      hasNotifierIds: false,
      selectTypeNames: TYPE_NAMES,
      levels: Array.from(SystemConstants.LEVELS),
      notifierRoles: [1, 2],
      notifierIds: [],
      ruleItem: [],
      hasDesignatedPost: true,
      enableMail: true, // 邮件
      enableWeChat: false, // 微信
      enableEnterpriseWechat: false,
      showEnableEnterpriseWechat: true,
      tabName: 'dataService',
      userConfigOpenDifferent: false,
      vesselReminderMethodDifferent: false
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    portAreaReminder() {
      if (!this.alertTypes || this.alertTypes.length === 0) {
        return []
      }
      return this.alertTypes.filter(item => [5].indexOf(item.code) > -1)
    },
    nodeAlertTypes() {
      if (!this.alertTypes || this.alertTypes.length === 0) {
        return []
      }
      return this.alertTypes.filter(item => [21, 22, 23, 24, 25, 26, 27, 28, 29].indexOf(item.code) > -1)
    },
    DestinationPortNodeAlertTypes() {
      if (!this.alertTypes || this.alertTypes.length === 0) {
        return []
      }
      return this.alertTypes.filter(item => [14, 15, 16, 17].indexOf(item.code) > -1)
    },
    warningTypes() {
      if (!this.alertTypes || this.alertTypes.length === 0) {
        return []
      }
      return this.alertTypes.filter(item => [5, 6, 7, 11, 14, 15, 16, 17, 21, 22, 23, 24, 25, 26, 27, 28, 29].indexOf(item.code) === -1)
    }
  },
  watch: {
    notifierRoles(newVal) {
      this.form.notifierRoles = newVal.join(',')
    },
    notifierIds(newVal) {
      this.form.notifierIds = newVal.join(',')
    },
    hasDesignatedPost(newVal) {
      if (!newVal) {
        this.notifierRoles = []
      }
    },
    enableMail(newVal) {
      this.form.enableMail = newVal ? 1 : 0
    },
    enableWeChat(newVal) {
      this.form.enableWeChat = newVal ? 1 : 0
    },
    enableEnterpriseWechat(newVal) {
      this.form.enableEnterpriseWechat = newVal ? 1 : 0
    },
    ruleItem(newVal) {
      const warnOpenSubscribe = LocalStorageUtils.getConfiguration('warnOpenSubscribe')
      if (!this.openSubscribe && !warnOpenSubscribe) {
        LocalStorageUtils.setConfiguration('warnOpenSubscribe', true)
        // 不开启且未提醒时，需要提醒
        this.learnMore()
      }
      if (!this.form.warningRuleItemList || this.form.warningRuleItemList.length === 0) {
        this.form.warningRuleItemList = [{}]
      }
      const warningRuleItemList = this.form.warningRuleItemList[0]
      warningRuleItemList.ruleItem = newVal.join(',')
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    selectType(value) {
      if (value === 0) {
        this.form.ignoreTime = ''
      } else {
        this.form.ignoreTime = 24
      }
    },
    init() {
      const params = deepClone(this.params)
      params.type = 2
      params.pageNum = 0
      params.lob
      delete params.open
      if (this.loadData) {
        getWarningRuleList(params).then((res) => {
          const data = res.data.list
          if (data && data.length > 0) {
            const form = data[0]
            this.notifierRoles = commonUtil.splitToNumberArray(form.notifierRoles, ',')
            this.notifierIds = commonUtil.splitToNumberArray(form.notifierIds, ',')
            this.hasDesignatedPost = form.notifierRoles && form.notifierRoles.length > 0
            this.hasNotifierIds = form.notifierIds && form.notifierIds.length > 0
            this.enableMail = form.enableMail === 1
            this.enableWeChat = form.enableWeChat === 1
            this.enableEnterpriseWechat = form.enableEnterpriseWechat === 1
            this.changeVesselReminderMethod()
            if (form.warningRuleItemList && form.warningRuleItemList.length > 0) {
              this.ruleItem = commonUtil.splitToNumberArray(form.warningRuleItemList[0].ruleItem, ',')
            }
            this.form = form
          } else {
            const codes = []
            for (const data of this.alertTypes) {
              codes.push(data.code)
            }
            this.ruleItem = codes
          }
        })
      }
    },
    async commitHandler() {
      this.form.lob = this.params.lob
      if (this.form.warningRuleItemList && this.form.warningRuleItemList.length > 0) {
        const warningRuleItem = this.form.warningRuleItemList[0]
        warningRuleItem.level = this.form.level
        warningRuleItem.notifierIds = this.form.notifierIds
        warningRuleItem.notifierRoles = this.form.notifierRoles
        warningRuleItem.enableMail = this.form.enableMail
        warningRuleItem.enableWeChat = this.form.enableWeChat
        warningRuleItem.enableEnterpriseWechat = this.form.enableEnterpriseWechat
      }
      this.fullscreenLoading = getLoading()
      try {
        this.form.configureName = this.form.configureName.trim()
        if (!this.form.configureName && !this.form.configureName.trim()) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ConfigureNameNotEmpty'))
          return
        }
        let error = false
        let msg = ''
        await checkDataServiceSave(this.form).then(res => {
          if (res.data) {
            for (const row of res.data) {
              if (row.type === 'configureName') {
                // 配置名重复
                msg += this.$t('CargoMsg.Cargo_ConfigureNameRepeat', [row.configureName]) + '<br/><br/>'
                error = true
              } else if (row.type === 'notifierRoles') {
                // 岗位重复
                const notifierRoles = ColumnUtils.constantsNameByMultiNumberValue(CargoOfRoleType.WARNING_ROLE_TYPES, row.notifierRoles, ',', true)
                msg += this.$t('CargoMsg.Cargo_NotifierRoleRepeat', [notifierRoles, row.configureName]) + '<br/><br/>'
                error = true
              } else if (row.type === 'notifierIds') {
                // 人员重复
                const notifierIds = ColumnUtils.getUserDefinedLabel(row.notifierIds)
                msg += this.$t('CargoMsg.Cargo_NotifierIdRepeat', [notifierIds, row.configureName]) + '<br/><br/>'
                error = true
              } else if (row.type === 'userConfigOpenDifferent') {
                this.userConfigOpenDifferent = true
              } else if (row.type === 'vesselReminderMethodDifferent') {
                this.vesselReminderMethodDifferent = true
              }
            }
          }
        })
        if (error) {
          // 去掉尾部的换行符
          msg = msg.substring(0, msg.length - 10)
          this.$message.warning({ message: msg, dangerouslyUseHTMLString: true })
          return
        }
        let message = ''
        if (this.userConfigOpenDifferent) {
          if (this.form.userConfigOpen === 1) {
            message += this.$t('CargoMsg.Cargo_UserConfigOpenDifferent') + '<br/>'
          } else {
            message += this.$t('CargoMsg.Cargo_UserConfigOpenDifferent2') + '<br/>'
          }
        }
        if (this.vesselReminderMethodDifferent) {
          if (this.form.vesselReminderMethod === 1) {
            message += this.$t('CargoMsg.Cargo_VesselReminderMethodDifferent') + '<br/>'
          } else {
            message += this.$t('CargoMsg.Cargo_VesselReminderMethodDifferent2') + '<br/>'
          }
        }
        if (message) {
          this.$message.warning({ message: message, dangerouslyUseHTMLString: true })
        }
        await saveWarningRule(this.form).then()
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.$emit('reload')
        this.close()
      } finally {
        this.fullscreenLoading.close()
      }
    },
    close() {
      this.$emit('close')
    },
    learnMore() {
      const h = this.$createElement
      this.$msgbox({
        message: h('div', { class: 'reminder-form' }, [
          h('i', { class: 'el-icon-warning' }, ''),
          h('span', { class: 'warning-title' }, this.$t('CargoMsg.Cargo_EnableDataServiceReminder')),
          h('p', null, this.$t('CargoMsg.Cargo_AskDataServiceReminder')),
          h('a', { attrs: { href: 'https://mp.weixin.qq.com/s/eUJYKQJS5nJvVnjogguW8w', target: '_blank' }}, 'https://mp.weixin.qq.com/s/eUJYKQJS5nJvVnjogguW8w'),
          h('p', null, this.$t('CargoMsg.Cargo_ContactDataServiceReminder'))
        ]),
        showCancelButton: false,
        confirmButtonText: this.$t('Message.GotIt')
      }).then(() => {
      })
    },
    changeVesselReminderMethod() {
      if (this.form.vesselReminderMethod === 1) {
        this.showEnableEnterpriseWechat = false
        this.enableEnterpriseWechat = false
      } else {
        this.showEnableEnterpriseWechat = true
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
  .reminder-form {
    .el-dialog__body {
      padding: 10px !important;
    }
    .el-icon-warning-outline{
      font-size: 16px;
      margin-right: 5px;
      color: orange;
    }
    /* 未访问的链接 */
    a:link {
      color: #FF0000;
    }

    /* 已访问的链接 */
    a:visited {
      color: $--color-primary;
    }

    /* 鼠标悬停链接 */
    a:hover {
      color: orange;
    }

    /* 已选择的链接 */
    a:active {
      color: #0000FF;
    }
    .primary-text {
      color: $--color-primary;
    }
    .el-icon-warning{
      font-size: 17px;
      color: $--color-primary;
      margin-right: 5px;
    }
    .warning-title{
      font-size: 16px;
    }
    .content-wrapper {
      display: flex;
      flex-direction: column;
      margin-top: 10px;
      width: 500px !important;
      .custom {
        .el-form-item__content {
          width: auto;
        }
      }

      .el-radio__label{
        font-size: 12px;
      }
      .el-form-item__content {
        width: 405px !important;
        textarea {
          width: 385px;
        }
        .cargo-advance-select-wrapper{
          width: 405px !important;
        }
      }
    }
  }
</style>
